import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import * as api from "../api"

export const getAgencies = createAsyncThunk("get-agencies", async () => {
    const response = await api.getAgencies()
    return response
})

export const getAgencyList = createAsyncThunk("get-agencies-list", async () => {
    const response = await api.getAgencyList()
    return response
})

export const getAgencyById = createAsyncThunk("get-agency-by-id", async (id) => {
    const response = await api.getAgencyById(id)
    return response
})

export const getAgenciesByPagination = createAsyncThunk(
    "get-agencies-by-pagination",
    async ({ pageIndex, numberOfRecords, orderBy, parentDescending, childDescending }) => {
        const response = await api.getAgenciesByPagination({
            pageIndex,
            numberOfRecords,
            orderBy,
            parentDescending,
            childDescending
        })
        return response
    }
)

export const searchAgenciesByPagination = createAsyncThunk(
    "search-agencies-by-pagination",
    async ({ searchTerm, searchIn, pageIndex, numberOfRecords, orderBy, parentDescending, childDescending }) => {
        const response = await api.searchAgenciesByPagination({
            searchTerm,
            searchIn,
            pageIndex,
            numberOfRecords,
            orderBy,
            parentDescending,
            childDescending
        })
        return response
    }
)

export const addAgency = createAsyncThunk("add-agency", async (payload) => {
    const response = await api.addAgency(payload)
    return response
})

export const editAgency = createAsyncThunk("edit-agency", async (payload) => {
    const response = await api.editAgency(payload)
    return response
})

export const exportAgencies = createAsyncThunk("export-agency", async () => {
    const response = await api.exportAgencies()
    return response
})

export const updateAgency = createAsyncThunk("update-agency", async (data) => {
    return data
})

export const getContactsByAgency = createAsyncThunk("get-contacts-by-agency", async (agencyId) => {
    const response = await api.getContactsByAgency(agencyId)
    return response
})

const agencySlice = createSlice({
    name: "agency",
    initialState: {
        data: [],
        agencyList: [],
        agenciesWithContacts: [],
        contacts: [],
        totalRecords: 0,
        agency: {},
        fetchStatus: "",
        action: ""
    },
    reducers: {
        updateAgency(state, action) {
            const { field, value } = action.payload
            state.agency = { ...state.agency, [field]: value }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAgencies.fulfilled, (state, action) => {
                state.agenciesWithContacts = action.payload?.records
                // state.totalRecords = action.payload?.totalRecords
                state.fetchStatus = "success"
                state.action = "getAgencies"
            })
            .addCase(getAgencies.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getAgencies"
            })
            .addCase(getAgencies.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getAgencies"
            })
            .addCase(getAgenciesByPagination.fulfilled, (state, action) => {
                state.data = action.payload?.records
                state.totalRecords = action.payload?.totalRecords
                state.fetchStatus = "success"
                state.action = "getAgenciesByPagination"
            })
            .addCase(getAgenciesByPagination.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getAgenciesByPagination"
            })
            .addCase(getAgenciesByPagination.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getAgenciesByPagination"
            })
            .addCase(searchAgenciesByPagination.fulfilled, (state, action) => {
                state.data = action.payload?.records
                state.totalRecords = action.payload?.totalRecords
                state.fetchStatus = "success"
                state.action = "searchAgenciesByPagination"
            })
            .addCase(searchAgenciesByPagination.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "searchAgenciesByPagination"
            })
            .addCase(searchAgenciesByPagination.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "searchAgenciesByPagination"
            })
            .addCase(addAgency.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "addAgency"
            })
            .addCase(addAgency.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "addAgency"
            })
            .addCase(addAgency.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "addAgency"
            })
            .addCase(exportAgencies.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "exportAgencies"
            })
            .addCase(exportAgencies.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "exportAgencies"
            })
            .addCase(exportAgencies.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "exportAgencies"
            })
            .addCase(editAgency.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "editAgency"
            })
            .addCase(editAgency.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "editAgency"
            })
            .addCase(editAgency.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "editAgency"
            })

            .addCase(updateAgency.fulfilled, (state, action) => {
                state.data = action.payload
                state.action = "updateAgency"
            })
            .addCase(updateAgency.pending, (state) => {
                state.action = "updateAgency"
            })
            .addCase(updateAgency.rejected, (state) => {
                state.action = "updateAgency"
            })
            .addCase(getAgencyList.fulfilled, (state, action) => {
                const rawItems = action.payload?.items ?? action.payload?.Items ?? []
                state.agencyList = Array.isArray(rawItems)
                    ? rawItems.map((item) => ({
                          ...item,
                          id: item?.id ?? item?.Id,
                          name: item?.name ?? item?.Name ?? ""
                      }))
                    : []
                state.fetchStatus = "success"
                state.action = "getAgenciesList"
            })
            .addCase(getAgencyList.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getAgenciesList"
            })
            .addCase(getAgencyList.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getAgenciesList"
            })
            .addCase(getContactsByAgency.fulfilled, (state, action) => {
                const rawItems = action.payload?.items ?? action.payload?.Items ?? []
                state.contacts = Array.isArray(rawItems)
                    ? rawItems.map((item) => ({
                          ...item,
                          id: item?.id ?? item?.Id,
                          firstName: item?.firstName ?? item?.FirstName ?? "",
                          lastName: item?.lastName ?? item?.LastName ?? ""
                      }))
                    : []
                state.fetchStatus = "success"
                state.action = "getContactsByAgency"
            })
            .addCase(getContactsByAgency.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getContactsByAgency"
            })
            .addCase(getContactsByAgency.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getContactsByAgency"
            })
            .addCase(getAgencyById.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "getAgencyById"
            })
            .addCase(getAgencyById.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getAgencyById"
            })
            .addCase(getAgencyById.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getAgencyById"
            })
    }
})

export default agencySlice

export const { name, actions, reducers } = agencySlice
